import { RoleUUID } from './rolesTypes';

import { SearchFilterNanoID } from '../searchFilters/searchFiltersTypes';

export class RoleCache {
  static indexCacheKey() {
    return 'roles';
  }

  static showCacheKey() {
    return 'role';
  }

  static financeRolesCacheKey() {
    return 'finance-roles';
  }

  static showQueryKey(roleUuid: RoleUUID) {
    return ['role', roleUuid];
  }

  static filteredCacheKey(searchFilterNanoId: SearchFilterNanoID) {
    return `roles-filtered-${searchFilterNanoId}`;
  }
}
